import AdminWalletSettings from 'components/Admin/WalletSettings/AdminWalletSettings';
import { FC } from 'react';

const AdminWalletSettingsListPage: FC = () => {
	return <AdminWalletSettings />;
};

export default AdminWalletSettingsListPage;
